import { useEffect, useCallback } from 'react';
export var useTallyWidget = function (shouldLoad, onSubmit) {
    var loadTallyEmbeds = useCallback(function () {
        document.querySelectorAll('iframe[data-tally-src]:not([src])').forEach(function (iframeEl) {
            iframeEl.src = iframeEl.dataset.tallySrc;
        });
    }, []);
    var handleTallyMessage = useCallback(function (e) {
        if (typeof e.data === 'string' && e.data.includes('Tally.FormSubmitted')) {
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        }
    }, [onSubmit]);
    useEffect(function () {
        if (!shouldLoad)
            return;
        var widgetScriptSrc = 'https://tally.so/widgets/embed.js';
        var existingScript = document.querySelector("script[src=\"".concat(widgetScriptSrc, "\"]"));
        var script = null;
        window.addEventListener('message', handleTallyMessage);
        if (existingScript) {
            // 스크립트가 이미 있는 경우에도 iframe 초기화 실행
            loadTallyEmbeds();
        }
        else {
            script = document.createElement('script');
            script.src = widgetScriptSrc;
            script.onload = loadTallyEmbeds;
            script.onerror = function (err) {
                console.error('Failed to load Tally widget script', err);
                loadTallyEmbeds();
            };
            document.body.appendChild(script);
        }
        return function () {
            // 불필요한 스크립트 제거 방지: 직접 append한 경우만 제거
            if (script && script.parentNode) {
                script.parentNode.removeChild(script);
            }
            window.removeEventListener('message', handleTallyMessage);
        };
    }, [shouldLoad, handleTallyMessage, loadTallyEmbeds]);
};
var TALLY_FORM_IDS = {
    blogPopup: 'nG7vak',
    welcome: 'wayXDX',
};
export var getTallyUrl = function (type, params) {
    var formId = TALLY_FORM_IDS[type];
    var base = "https://tally.so/r/".concat(formId, "?transparentBackground=1");
    var query = new URLSearchParams(params);
    return "".concat(base, "&").concat(query.toString());
};
